import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import DataTable from 'datatables.net-bs5';

document.addEventListener('DOMContentLoaded', () => {
  new DataTable('#downtime', {paging: false});
  document.documentElement.dataset.tableReady = 'true';
});
